<div
  class="jp--stats button button--style-white-04 button--style-white-04-bordered padding-x-12 h-40"
>
  <span> Total Players: </span>
  {{ jackpotService.uniquePlayersNumber() }}
</div>
<div
  class="jp--stats button button--style-white-04 button--style-white-04-bordered padding-x-12 h-40"
>
  <span> Your Deposit: </span>
  {{
    jackpotService.sessionDepositValue() | currency : "USD" : "symbol" : "1.2-2"
  }}
</div>
<div
  class="jp--stats button button--style-white-04 button--style-white-04-bordered padding-x-12 h-40"
>
  <span> Win Chance: </span>
  {{ jackpotService.sessionChance() | number : "1.2-2" }}%
</div>
